import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import MuiTooltip from '@material-ui/core/Tooltip'

const Value = styled.div`
  max-width: ${props => props.maxWidth}px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

const ToolTipEllipsis = ({ text, maxWidth, tooltipTitle }) => (
  <MuiTooltip title={tooltipTitle || text}>
    <Value maxWidth={maxWidth}>{text}</Value>
  </MuiTooltip>
)

ToolTipEllipsis.propTypes = {
  text: PropTypes.string,
  maxWidth: PropTypes.number
}

export default ToolTipEllipsis
